import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  ShoppingOutlined,
  AppstoreOutlined,
  ThunderboltOutlined,
  ShoppingCartOutlined,
  ImportOutlined,
  TeamOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { malzemelerAPI, urunlerAPI, uretimlerAPI, satislarAPI, alislarAPI, carilerAPI } from '../services/api';

function Anasayfa() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    malzeme: 0,
    urun: 0,
    menu: 0,
    uretim: 0,
    satis: 0,
    satisTutar: 0,
    gider: 0,
    cari: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [malRes, urRes, retRes, satRes, alRes, caRes] = await Promise.all([
          malzemelerAPI.getAll(),
          urunlerAPI.getAll(),
          uretimlerAPI.getAll(),
          satislarAPI.getAll(),
          alislarAPI.getAll(),
          carilerAPI.getAll(),
        ]);
        setStats({
          malzeme: malRes.data.length,
          urun: urRes.data.length,
          uretim: retRes.data.length,
          satis: satRes.data.length,
          satisTutar: satRes.data.reduce((acc, s) => acc + Number(s.toplam_tutar || 0), 0),
          gider: alRes.data.length,
          cari: caRes.data.length,
        });
      } catch (err) {
        message.error('İstatistikler yüklenemedi');
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const cards = [
    { title: 'Toplam Malzeme', value: stats.malzeme, icon: <ShoppingOutlined />, color: '#3B82F6', bg: '#EFF6FF', path: '/malzemeler' },
    { title: 'Toplam Ürün', value: stats.urun, icon: <AppstoreOutlined />, color: '#10B981', bg: '#ECFDF5', path: '/urunler' },
    { title: 'Toplam Üretim', value: stats.uretim, icon: <ThunderboltOutlined />, color: '#F59E0B', bg: '#FFFBEB', path: '/uretimler' },
    { title: 'Toplam Satış', value: stats.satis, icon: <ShoppingCartOutlined />, color: '#EF4444', bg: '#FEF2F2', path: '/satislar' },
    { title: 'Satış Tutarı', value: stats.satisTutar, icon: <DollarOutlined />, color: '#16A34A', bg: '#F0FDF4', suffix: ' TL', path: '/satislar' },
    { title: 'Toplam Alış', value: stats.gider, icon: <ImportOutlined />, color: '#06B6D4', bg: '#ECFEFF', path: '/alislar' },
    { title: 'Toplam Cari', value: stats.cari, icon: <TeamOutlined />, color: '#EC4899', bg: '#FDF2F8', path: '/cariler' },
  ];

  return (
    <div style={{ overflowX: 'hidden' }}>
      <div style={{ marginBottom: 24 }}>
        <span style={{
          fontSize: 'clamp(20px, 4vw, 32px)',
          fontWeight: 900,
          letterSpacing: 'clamp(1px, 0.4vw, 4px)',
          color: '#FF6B00',
          fontFamily: "'Arial Black', 'Helvetica Neue', sans-serif",
        }}>
          EVDEYE
        </span>
        <p style={{ color: '#999', marginTop: 4, fontSize: 13 }}>Restoran Yonetim Paneli</p>
      </div>
      <Row gutter={[12, 12]}>
        {cards.map((card) => (
          <Col xs={12} sm={12} md={8} lg={6} xl={6} key={card.title}>
            <Card
              hoverable
              loading={loading}
              onClick={() => card.path && navigate(card.path)}
              style={{ borderTop: `3px solid ${card.color}`, borderRadius: 8, cursor: card.path ? 'pointer' : 'default' }}
              styles={{ body: { background: card.bg, padding: 16 } }}
            >
              <Statistic
                title={<span style={{ color: '#666', fontSize: 12 }}>{card.title}</span>}
                value={card.value}
                precision={card.suffix ? 2 : 0}
                suffix={card.suffix || ''}
                prefix={<span style={{ color: card.color, fontSize: 20, marginRight: 6 }}>{card.icon}</span>}
                valueStyle={{ color: card.color, fontSize: 'clamp(16px, 2.2vw, 22px)', fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Anasayfa;